import { create, type StoreApi, type UseBoundStore } from "zustand";
import { immer } from "zustand/middleware/immer";

interface RuntimeState {
  /** 当前页面 ID */
  currentPageId: string | null;
  /** 页面配置缓存 */
  pageConfigs: Record<string, any>;
  /** 加载状态 */
  loading: boolean;
  /** 错误信息 */
  error: string | null;

  // Actions
  setCurrentPage: (pageId: string) => void;
  setPageConfig: (pageId: string, config: any) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
  clearCache: () => void;
}

export const useRuntimeStore: UseBoundStore<StoreApi<RuntimeState>> =
  create<RuntimeState>()(
  immer((set) => ({
    currentPageId: null,
    pageConfigs: {},
    loading: false,
    error: null,

    setCurrentPage: (pageId) =>
      set((state) => {
        state.currentPageId = pageId;
      }),

    setPageConfig: (pageId, config) =>
      set((state) => {
        state.pageConfigs[pageId] = config;
      }),

    setLoading: (loading) =>
      set((state) => {
        state.loading = loading;
      }),

    setError: (error) =>
      set((state) => {
        state.error = error;
      }),

    clearCache: () =>
      set((state) => {
        state.pageConfigs = {};
      }),
  }))
);

export default useRuntimeStore;
